import { React } from "react";
import { BiEdit } from "react-icons/bi";

export default function EditButton({
  accountAccess = 3,
  title = "Bild ändern",
  onButtonClicked,
  className = "cursor-pointer text-freisicht transition transform hover:scale-105 hover:text-darkGreen",
  disabled = " ",
}) {
  return (
    <>
      {accountAccess > 1 ? (
        <button className="float-left pl-2 md:pl-4 " onClick={onButtonClicked}>
          <div className={className + disabled} title={title}>
            <BiEdit></BiEdit>
          </div>
        </button>
      ) : (
        ""
      )}
    </>
  );
}
